import { groupBy } from 'lodash';

import type * as Pricing from '@/pricing/types';

export interface Usage {
    id: string;
    displayName: string;
    options: {
        id: string;
        value?: string;
    }[];
}

export function getTableSections(rows: Pricing.Row[]): Record<string, Pricing.Row[]> {
    return groupBy(rows, (row) => row.area);
}

export function getKeyItems(rows: Pricing.Row[]): Pricing.Row[] {
    return rows.filter((row) => Boolean(row.is_key_item));
}
